module.exports = __webpack_public_path__ + "static/media/tablet2.8764266d.png";